import { useContext } from "react";
import { ConfirmDialogContext } from "../providers/confirmDialogContext";

export const useConfirmDialog = () => {
  const context = useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error("useConfirmDialog must be used within a ConfirmDialogProvider");
  }
  return context.openDialog;
};
